<template>
  <div class="flex flex-col gap-4">
    <TextHeader>Marktinzichten</TextHeader>
    <ToolbarComponent no-mode no-metering-point-menu />
    <DayAheadChartPanel :date-range="filterStore.dateRange" />
    <BalanceDeltaChartPanel :date-range="filterStore.dateRange" />
  </div>
</template>

<script setup>
import { TextHeader } from "@repowerednl/ui-component-library"
import DayAheadChartPanel from "@/components/panels/DayAheadChartPanel.vue"
import BalanceDeltaChartPanel from "@/components/panels/BalanceDeltaChartPanel.vue"
import ToolbarComponent from "@/components/navigation/ToolbarComponent.vue"
import useFilterStore from "@/stores/filterStore.js"

const filterStore = useFilterStore()
</script>
